var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondSectionLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_489_3213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.970459,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_489_3213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9705C12.55 12.9705 13.0208 12.7746 13.4125 12.383C13.8042 11.9913 14 11.5205 14 10.9705C14 10.4205 13.8042 9.94963 13.4125 9.55796C13.0208 9.16629 12.55 8.97046 12 8.97046C11.45 8.97046 10.9792 9.16629 10.5875 9.55796C10.1958 9.94963 10 10.4205 10 10.9705C10 11.5205 10.1958 11.9913 10.5875 12.383C10.9792 12.7746 11.45 12.9705 12 12.9705ZM12 20.3205C14.0333 18.4538 15.5417 16.758 16.525 15.233C17.5083 13.708 18 12.3538 18 11.1705C18 9.35379 17.4208 7.86629 16.2625 6.70796C15.1042 5.54963 13.6833 4.97046 12 4.97046C10.3167 4.97046 8.89583 5.54963 7.7375 6.70796C6.57917 7.86629 6 9.35379 6 11.1705C6 12.3538 6.49167 13.708 7.475 15.233C8.45833 16.758 9.96667 18.4538 12 20.3205ZM12 22.9705C9.31667 20.6871 7.3125 18.5663 5.9875 16.608C4.6625 14.6496 4 12.8371 4 11.1705C4 8.67046 4.80417 6.67879 6.4125 5.19546C8.02083 3.71213 9.88333 2.97046 12 2.97046C14.1167 2.97046 15.9792 3.71213 17.5875 5.19546C19.1958 6.67879 20 8.67046 20 11.1705C20 12.8371 19.3375 14.6496 18.0125 16.608C16.6875 18.5663 14.6833 20.6871 12 22.9705Z",
    fill: "#F8F8F8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSectionLocation);
export default __webpack_public_path__ + "static/media/secondSection-Location.a65f204f59b761e40cd9cece9d3248bb.svg";
export { ForwardRef as ReactComponent };